module.exports = __webpack_public_path__ + "img/icon-prod-shelly.c4af1903.svg";